import React, { Fragment, FunctionComponent } from 'react';
import { Typography } from '@rbx/ui';
import ColoredMethod from '@modules/openCloud/page/main/components/ColoredMethod';
import { HttpMethods } from '@modules/openCloud/utils/oasTypes';
import useEndpointStyles from './roas/CloudV2Endpoint.styles';

export interface ResourcePathItemProps {
  method: HttpMethods;
  resourcePathName: string;
  active?: boolean;
}

const ResourcePathItem: FunctionComponent<React.PropsWithChildren<ResourcePathItemProps>> = ({
  method,
  resourcePathName,
  active,
}) => {
  const {
    classes: { resourcePathItem },
  } = useEndpointStyles();
  return (
    <Fragment key={resourcePathName}>
      <Typography
        className={resourcePathItem}
        variant='code'
        color={active ? 'primary' : 'secondary'}>
        <ColoredMethod method={method as HttpMethods} /> {resourcePathName}
      </Typography>
    </Fragment>
  );
};

export default ResourcePathItem;
